module.exports = __webpack_public_path__ + "assets/img/cart.771eb15e.gif";